var map = {
	"./componentes.jpg": 4050,
	"./componuevos.jpg": 5554,
	"./composegunda.jpg": 7808,
	"./consumibles1.jpeg": 1518,
	"./contacto1.jpeg": 6769,
	"./contacto2.jpg": 64,
	"./fondopantalla.jpg": 4167,
	"./fondopantalla2.jpg": 8668,
	"./fondopantalla3.jpg": 7898,
	"./fondopantalla4.jpg": 8019,
	"./fondopantalla5.jpg": 4652,
	"./fondopantalla6.jpg": 5913,
	"./fondopantalla7.jpeg": 3834,
	"./fondopantalla8.jpg": 4326,
	"./logotipo.png": 1130,
	"./logotipobola.png": 2672,
	"./oportunidades.jpg": 9770,
	"./ordenadores.jpg": 1158,
	"./ordenanuevos.jpg": 8666,
	"./ordenasegunda.jpg": 1468,
	"./rep1.jpeg": 1079,
	"./reparaciones1.jpg": 5444,
	"./tienda2.jpeg": 5704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7183;